const colors = [
  'red',
  'fuchsia',
  'purple',
  'daisy-bush',
  'tory-blue',
  'navy',
  'blue',
  'bondi-blue',
  'pine-green',
  'limeaid',
  'las-palmas',
  'saffron',
  'orange',
  'tangerine',
  'cinnabar',
  'dark-brown',
  'pantone',
  'san-juan',
];

export default function getColor(fullName) {
  return colors[(fullName || '').split('').reduce((out, curr) => (
    out + curr.charCodeAt(0)
  ), 0) % colors.length];
}
